import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { SnackbarProvider, MaterialDesignContent, useSnackbar } from 'notistack';
import { styled } from '@mui/material/styles';
import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey('e0d9bb8070ce0054c9d9ecb6e82cb58fTz0wLEU9MzI0NzIxNDQwMDAwMDAsUz1wcmVtaXVtLExNPXBlcnBldHVhbCxLVj0y'); 

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
    '&.notistack-MuiContent-success': {
        backgroundColor: '#00bd9d',
    },
    '&.notistack-MuiContent-error': {
        backgroundColor: '#f06548',
    },
}));

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <SnackbarProvider
  Components={{
    success: StyledMaterialDesignContent,
    error: StyledMaterialDesignContent,
  }}
  // persist={true}
  // action
  autoHideDuration={7000} >
    <App />
  </SnackbarProvider>
  // <React.StrictMode>
    // <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
